import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import './styles/design-system.scss';

// Fix Leaflet default icon paths so marker images load correctly when bundled
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

// Initialize theme
const savedTheme = localStorage.getItem('theme') || 'light';
const root = document.documentElement;
if (savedTheme === 'dark') {
  root.classList.add('dark-mode');
  root.setAttribute('data-bs-theme', 'dark');
} else {
  root.classList.add('light-mode');
  root.setAttribute('data-bs-theme', 'light');
}

// Initialize locale and RTL
const savedLocale = localStorage.getItem('locale') || 'en';
document.documentElement.lang = savedLocale;
if (savedLocale === 'ar') {
  document.documentElement.dir = 'rtl';
} else {
  document.documentElement.dir = 'ltr';
}

// Create and mount the app with error handling
const mountApp = () => {
  const appElement = document.getElementById('app');
  if (!appElement) {
    console.error('App element (#app) not found in DOM');
    return;
  }

  try {
    const app = createApp(App);
    app.use(store);
    app.use(router);
    app.use(i18n);
    
    // Global error handler
    app.config.errorHandler = (err, instance, info) => {
      console.error('Vue Error:', err);
      console.error('Error Info:', info);
      console.error('Component Instance:', instance);
      // Don't let errors crash the app
    };
    
    // Handle unhandled promise rejections
    window.addEventListener('unhandledrejection', event => {
      console.error('Unhandled Promise Rejection:', event.reason);
      event.preventDefault();
    });
    
    app.mount('#app');
    console.log('Application mounted successfully');
  } catch (error) {
    console.error('Failed to initialize application:', error);
    appElement.innerHTML = `
      <div style="padding: 2rem; text-align: center; font-family: sans-serif;">
        <h1>Application Error</h1>
        <p>Failed to load the application. Please check the browser console for details.</p>
        <pre style="text-align: left; background: #f5f5f5; padding: 1rem; border-radius: 4px; overflow: auto; max-width: 800px; margin: 1rem auto;">${error.stack || error.message}</pre>
      </div>
    `;
  }
};

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountApp);
} else {
  mountApp();
}
